module.exports = __webpack_public_path__ + "img/slide4.28c9e06c.png";